import { Component,  Inject,  Input } from '@angular/core';
import { Wrapper } from '../wrapper.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JoiAccount } from 'globals/store/accounts.data';
import { ImageUploaderResult } from 'globals/store/share.data';
import { JoiBrandImage } from 'globals/store/publish.data';
import { DeleteButtonComponent } from '../buttons/delete-button.component';
import { CommonModule } from '@angular/common';
import { BrandImageTextAdderComponent } from './brand-image-text-adder.component';
import { BigDialogWrapperComponent } from '../wrappers/big-dialog-wrapper.component';
import { createId } from 'globals/helpers/helpers';

@Component({
    selector: 'event-thumbs-dialog',
    template: `
<wide-dialog-wrapper
  *ngIf="!!account"
  [backgroundColor]="'black'"
  [dialogTitle]="'Event list thumbnails'"
  [disabled]="false"
  [delete]="false"
  [successLabel]="'DONE'"
  (onSubmit)="dialogRef.close(data)"
>
  <div class="choices">
    <div class="text-adder-holder">
      <brand-image-text-adder 
        [maxMegs]="2" 
        [uploadText]="'UPLOAD EVENT LIST THUMBNAIL'"
        [width]="275" 
        [height]="200"
        [imageType]="'event-thumb'"
        [uniqueFormIdentifier]="'desktop'"
        [accountId]="account.id"
        (addImage)="addImage($event)"
      ></brand-image-text-adder>
    </div>
    <div class="thumb empty" [ngClass]="{ selected: data.thumbLink === null }"  (click)="data.thumbLink = null">
      <img [src]="'assets/placeholder_event_list.png'" />
    </div>
    <div class="thumb" *ngFor="let thumb of account.eventThumbs; trackBy: trackById" 
      [ngClass]="{ selected: thumb.link === data.thumbLink }" 
      (click)="clickThumb(thumb)">
      <img [src]="thumb.link"/>
      <delete-button [deleteTitle]="deleteTitle" [deleteText]="deleteText" (delete)="deleteThumb(thumb)"></delete-button>
      
    </div>
  </div>
</wide-dialog-wrapper>

`,
    styles: [`
  .choices { display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-around; padding-bottom: 20px; }
  .text-adder-holder { height: 200px; margin: 20px 10px 0; display: flex; justify-content: center; flex-direction: column; }
  brand-image-text-adder { height: fit-content; }
  .thumb { padding: 5px 5px 0; margin: 20px 10px 0; height: fit-content; border: 2px solid #ddd; border-radius: 6px; display: flex; flex-direction: column; }
  .thumb.empty { padding-bottom: 5px; }
  .thumb.selected { border: 2px solid var(--primary); }
  .thumb delete-button { width: fit-content; margin: 5px 0 0 auto; }
  .thumb img { height: 200px; width: 275px; background: var(--contentbg); cursor: pointer;  }
  :host ::ng-deep wide-dialog-wrapper #farRightButton { margin-right: 20px !important; }
  `],
    styleUrls: ['./brand-image.scss'],
    standalone: true,
    imports: [DeleteButtonComponent, CommonModule, BrandImageTextAdderComponent, BigDialogWrapperComponent],
})
export class EventThumbsDialogComponent extends Wrapper<EventThumbsDialogComponent> {
  imageId = createId()
  account: Partial<JoiAccount>
  deleteTitle = 'Remove event list thumbnail'
  deleteText = 'The event list thumbnail will no longer show in this list but will not disappear from events it was previously applied to until replaced'
  _file = 'event-thumbs-dialog'

  constructor(public dialogRef: MatDialogRef<EventThumbsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: EventThumbsData) {
    super()
    console.log({ data })
    this.subProp(this.store.select('accounts', 'entities', data.accountId), 'account')
  }

  async clickThumb(thumb: JoiBrandImage) {
    if (this.data.thumbLink === thumb.link) return
  
    this.data.thumbLink = thumb.link
  }
  
  addImage(result: ImageUploaderResult) {
    if (!result) return
    const eventThumbs = this.account.eventThumbs
    eventThumbs.unshift(({ id: this.imageId, name: result.originalName, link: result.photoUrl }))
    this.accountService.updateAccount(this.account.id, { eventThumbs }, { file: this._file, function: 'updateTemplates', error: new Error(), message: 'There was an error updating event thumbs' })
    this.imageId = createId()
  }

  deleteThumb(thumb: JoiBrandImage) {
    const eventThumbs = this.account.eventThumbs.filter(t => t.id !== thumb.id)
    this.accountService.updateAccount(this.account.id, { eventThumbs }, { file: this._file, function: 'updateTemplates', error: new Error(), message: 'There was an error updating event thumbs' })
  }

}

export interface EventThumbsData {
  thumbLink: string
  accountId: string
}



